import { directDottedConstants } from '../constants/directDoted.constants';
import TeamServices from '../services/team.services';
import GoalService from '../services/goal.services';
import { okrDetailConstants } from '../constants/okr/okrDetails.constants';
import { commentsConstants } from '../constants/comments.constants';
import {
  applyHideEmptyOkrsToApiParams,
  buildDirectDotedFilterMeta,
  buildFilterDataSet,
  bumpDirectDotedOkrFetchGeneration,
  isCurrentDirectDotedOkrFetch,
} from '../utils/okrFilterParams.util';

let teamServices = new TeamServices();
let goalService = new GoalService();

export const directDotedActions = {
  getMydirectAndDoted,
  getVelocityRank,
  getDirectDotedOkrs,
};

function getMydirectAndDoted() {
  return (dispatch) => {
    showLoaderWidget($('#content'));
    teamServices
      .getMydirectAndDoted()
      .then((response) => {
        if (response.data) {
          dispatch(success(response.data.data));
          removeLoaderWidget();
        }
      })
      .catch((err) => {
        dispatch(fail());
        removeLoaderWidget();
      });
  };

  function success(data) {
    return { type: directDottedConstants.GET_MEMBER_SUCCESS, data };
  }
  function fail() {
    return { type: directDottedConstants.GET_MEMBER_FAIL };
  }
}

function getVelocityRank(memberList) {
  function success(data) {
    return { type: directDottedConstants.UPDATE_VELECITY_SUCCESS, data };
  }
  function fail() {
    return { type: directDottedConstants.UPDATE_VELECITY_FAIL };
  }

  return (dispatch) => {
    const promiseApis = [];
    if (memberList?.length) {
      memberList.forEach((user) => {
        promiseApis.push(teamServices.getVelocityRank({ userId: user.userId }));
      });
      let isCompletedReq = false;
      if (promiseApis?.length) {
        Promise.all([...promiseApis]).then((values) => {
          if (values) {
            memberList.forEach((member, index) => {
              const valueResponse = values[index] ?? [];
              const { data = {} } = valueResponse;
              const { velocityRank = '-1' } = data;
              member.velocity = velocityRank;
            });
            isCompletedReq = true;
            dispatch(success(memberList));
          }
        });
      }
      if (!isCompletedReq) {
        dispatch(success(memberList));
      }
    }
  };
}

function getDirectDotedOkrs(params, options = {}) {
  return (dispatch) => {
    const fetchGeneration = bumpDirectDotedOkrFetchGeneration();
    const apiParams = { ...params };
    const filterMeta = buildDirectDotedFilterMeta(apiParams, options.dueStatus === true);
    const offset = apiParams.offset == null ? 0 : Number(apiParams.offset);

    if (offset === 0) {
      dispatch(resetTeamsData());
    }
    if (apiParams.overdueKR) {
      apiParams.overdueKR = 1;
    } else {
      delete apiParams.overdueKR;
    }
    if (options.uiFiltersApplied === true) {
      apiParams.uiFiltersApplied = 1;
    } else {
      delete apiParams.uiFiltersApplied;
    }
    applyHideEmptyOkrsToApiParams(apiParams, {
      clientFilterApplied: options.clientFilterApplied === true,
      dueStatus: options.dueStatus === true,
      appliedListFilters: options.appliedListFilters === true,
    });

    const requestMeta = { ...filterMeta };
    if (options.filterCount === 0) {
      requestMeta.filterCount = 0;
      requestMeta.filterDataSet = buildFilterDataSet(apiParams);
      requestMeta.fromFilter = true;
    } else if (options.filterCount !== undefined) {
      requestMeta.filterCount = options.filterCount;
    }
    if (options.clientFilterApplied === false) {
      requestMeta.clientFilterApplied = false;
    }
    if (options.dueStatus === true || apiParams.overdueKR) {
      requestMeta.dueStatus = true;
    } else if (options.dueStatus === false && offset === 0) {
      requestMeta.dueStatus = false;
    }

    return goalService
      .getMyDirectsOKR(apiParams)
      .then((response) => {
        if (!isCurrentDirectDotedOkrFetch(fetchGeneration)) {
          return null;
        }
        if (response.data) {
          dispatch(success(response.data, requestMeta));
          dispatch(commentsData(response.data));
        }
        return response;
      })
      .catch((err) => {
        dispatch(fail());
        throw err;
      });
  };

  function success(data, meta = {}) {
    return { type: okrDetailConstants.GET_DIRECT_DOTTED_OKRS_SUCCESS, data, meta };
  }
  function commentsData(data) {
    return { type: commentsConstants.SET_USER_DATA, data };
  }
  function fail() {
    return { type: directDottedConstants.GET_DIRECT_DOTED_OKR_FAIL };
  }
  function resetTeamsData() {
    return { type: okrDetailConstants.RESET_GOAL_DATA };
  }
}
